import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class RebNgxAvatarComponent {
    constructor() {
        /**
         * First character
         *
         * @required
         */
        this.firstChar = '';
        /**
         * Last character
         *
         * @required
         */
        this.lastChar = '';
        /**
         * Size
         *
         * @required
         */
        this.size = 'large';
        /**
         * Fonts color
         */
        this.fontColor = '#FDD';
        /**
         * Background color
         */
        this.backgroundColor = '#0E2655';
    }
    getFirstCharOfString(text) {
        return text.trim().charAt(0).toUpperCase();
    }
    get classes() {
        return ['rn-avatar', `${this.size}`];
    }
    ngOnInit() {
        this.firstChar = this.getFirstCharOfString(this.firstChar);
        this.lastChar = this.getFirstCharOfString(this.lastChar);
    }
}
RebNgxAvatarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxAvatarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
RebNgxAvatarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.10", type: RebNgxAvatarComponent, selector: "reb-ngx-avatar", inputs: { firstChar: "firstChar", lastChar: "lastChar", size: "size", fontColor: "fontColor", backgroundColor: "backgroundColor" }, ngImport: i0, template: "<div\n  [ngClass]=\"classes\"\n  [style.color]=\"fontColor ? fontColor : ''\"\n  [style.backgroundColor]=\"backgroundColor ? backgroundColor : ''\"\n>\n  <span>{{ firstChar === '' ? '?' : firstChar }}</span>\n  <span>{{ lastChar === '' ? '?' : lastChar }}</span>\n</div>\n", styles: [".rn-avatar{border-radius:var(--border-rounded);display:flex;justify-content:center;align-items:center;pointer-events:none}.rn-avatar.small{font-family:var(--body-font-family);font-weight:var(--font-weight-500);font-size:var(--font-size-12);line-height:var(--font-line-height-15);width:36px;height:36px}.rn-avatar.medium{font-family:var(--heading-font-family);font-weight:var(--font-weight-700);font-size:var(--font-size-16);line-height:var(--font-line-height-19);width:42px;height:42px}.rn-avatar.large{font-family:var(--heading-font-family);font-weight:var(--font-weight-700);font-size:var(--font-size-18);line-height:var(--font-line-height-23);width:64px;height:64px}\n"], directives: [{ type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxAvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'reb-ngx-avatar', template: "<div\n  [ngClass]=\"classes\"\n  [style.color]=\"fontColor ? fontColor : ''\"\n  [style.backgroundColor]=\"backgroundColor ? backgroundColor : ''\"\n>\n  <span>{{ firstChar === '' ? '?' : firstChar }}</span>\n  <span>{{ lastChar === '' ? '?' : lastChar }}</span>\n</div>\n", styles: [".rn-avatar{border-radius:var(--border-rounded);display:flex;justify-content:center;align-items:center;pointer-events:none}.rn-avatar.small{font-family:var(--body-font-family);font-weight:var(--font-weight-500);font-size:var(--font-size-12);line-height:var(--font-line-height-15);width:36px;height:36px}.rn-avatar.medium{font-family:var(--heading-font-family);font-weight:var(--font-weight-700);font-size:var(--font-size-16);line-height:var(--font-line-height-19);width:42px;height:42px}.rn-avatar.large{font-family:var(--heading-font-family);font-weight:var(--font-weight-700);font-size:var(--font-size-18);line-height:var(--font-line-height-23);width:64px;height:64px}\n"] }]
        }], propDecorators: { firstChar: [{
                type: Input
            }], lastChar: [{
                type: Input
            }], size: [{
                type: Input
            }], fontColor: [{
                type: Input
            }], backgroundColor: [{
                type: Input
            }] } });

class RebNgxAvatarModule {
}
RebNgxAvatarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxAvatarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RebNgxAvatarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxAvatarModule, declarations: [RebNgxAvatarComponent], imports: [CommonModule], exports: [RebNgxAvatarComponent] });
RebNgxAvatarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxAvatarModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxAvatarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RebNgxAvatarComponent],
                    imports: [CommonModule],
                    exports: [RebNgxAvatarComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { RebNgxAvatarComponent, RebNgxAvatarModule };
